import { lazy, type FC } from 'react';

const SideBarEntryAir = lazy(() => import('../pages/Broker/Devices/SideBarDevices/Air/SideBarEntryAir'));
const SideBarEntryIrrigation = lazy(() => import('../pages/Broker/Devices/SideBarDevices/Irrigation/SideBarEntryIrrigation'));
const SideBarEntryLighting = lazy(() => import('../pages/Broker/Devices/SideBarDevices/Lighting/SideBarEntryLighting'));
const SideBarEntryNDSWrapped = lazy(() => import('../pages/Broker/Devices/SideBarDevices/NDS/SideBarEntryNDS'));
const SideBarEntryAlert = lazy(() => import('../pages/Broker/Logs/Alerts/SideBarEntryAlert'));
const SeasonsSidebar = lazy(() => import('../pages/Broker/Seasons/SeasonsSidebar'));
const SideBarEntryRackUtil = lazy(() => import('../pages/Broker/Trays/Sidebar/SideBarEntryRackUtil'));
const SeasonsSidebarDelete = lazy(() => import('../pages/Broker/Seasons/SeasonsSidebarDelete'));
const SeedsSidebar = lazy(() => import('../pages/Broker/Seeds/SeedsSidebar'));
const SideBarSeasonTrayEditor = lazy(() => import('../pages/Broker/Seasons/SideBarSeasonTrayEditor'));
const SideBarSeasonEntry = lazy(() => import('../pages/Broker/Seasons/SideBarSeasonEntry'));
const SideBarEntryTraySeasonEntryPoint = lazy(() => import('../pages/Broker/Trays/Sidebar/SideBarEntryTraySeasonEntryPoint'));
const SideBarEntryCo2 = lazy(() => import('../pages/Broker/Devices/SideBarDevices/Co2/SideBarEntryCo2'));
const SeedsSidebarEdit = lazy(() => import('../pages/Broker/Seeds/SeedsSidebarEdit'));
const SideBarEntryFertigator = lazy(() => import('../pages/Broker/Devices/SideBarDevices/Fertigator/SideBarEntryFertigator'));
const SideBarEntryTraybot = lazy(() => import('../pages/Broker/Devices/SideBarDevices/Traybot/SideBarEntryTraybot'));
const SidebarCustomConsoleGraph = lazy(() => import('../pages/Broker/CustomConsole/SidebarCustomConsoleGraph'));
const SideBarEntryLift = lazy(() => import('../pages/Broker/Devices/SideBarDevices/Lift/SideBarEntryLift'));
const SidebarEntryCamera = lazy(() => import('../pages/Broker/Devices/SideBarDevices/Camera/SideBarEntryCamera'));
const SideBarEntryHarvester = lazy(() => import('../pages/Broker/Devices/SideBarDevices/Harvester/SideBarEntryHarvester'));
const SideBarEntrySentry = lazy(() => import('../pages/Broker/Devices/SideBarDevices/Sentry/SideBarEntrySentry'));
const SideBarEntrySeeder = lazy(() => import('../pages/Broker/Devices/SideBarDevices/Seeder/SideBarEntrySeeder'));
const SideBarEntryPackager = lazy(() => import('../pages/Broker/Devices/SideBarDevices/Packager/SideBarEntryPackager'));
const SideBarEntryGuard = lazy(() => import('../pages/Broker/Devices/SideBarDevices/Guard/SideBarEntryGuard'));
const SideBarEntryTransfer = lazy(() => import('../pages/Broker/Devices/SideBarDevices/Transfer/SideBarEntryTransfer'));
const SideBarEntryLiftCore = lazy(() => import('../pages/Broker/Devices/SideBarDevices/LiftCore/SideBarEntryLiftCore'));
const SideBarEntryConveyor = lazy(() => import('../pages/Broker/Devices/SideBarDevices/Conveyor/SideBarEntryConveyor'));
const CostsSideBarEdit = lazy(() => import('../pages/Broker/Costs/CostsSideBarEdit'));
const SideBarEntryDimmer = lazy(() => import('../pages/Broker/Devices/SideBarDevices/Dimmer/SideBarEntryDimmer'));
const SideBarEntryDimmerCore = lazy(() => import('../pages/Broker/Devices/SideBarDevices/DimmerCore/SideBarEntryDimmerCore'));
const SideBarEntryLightingCore = lazy(() => import('../pages/Broker/Devices/SideBarDevices/LightingCore/SideBarEntryLightingCore'));
const MCPSidebar = lazy(() => import('../pages/mcp/sidebar/MCPSidebar'));
const SideBarEntrySprinkler = lazy(() => import('src/pages/Broker/Devices/SideBarDevices/Sprinkler/SideBarEntrySprinkler'));
const SideBarEntrySprinklerCore = lazy(() => import('src/pages/Broker/Devices/SideBarDevices/SprinklerCore/SideBarEntrySprinklerCore'));
const RulesSidebar = lazy(() => import('../pages/Broker/Rules/RulesSidebar'));
const RulesSidebarEdit = lazy(() => import('../pages/Broker/Rules/RulesSidebarEdit'));

const routes: { path: string; component: FC<any>; fullscreen?: boolean }[] = [
  {
    path: 'air/:deviceId',
    component: SideBarEntryAir,
  },
  {
    path: 'fertigator/:deviceId',
    component: SideBarEntryFertigator,
  },
  {
    path: 'sprinklers/:locationString',
    component: SideBarEntryNDSWrapped,
  },
  {
    path: 'nds/:locationString',
    component: SideBarEntryNDSWrapped,
  },
  {
    path: 'irrigation/:deviceId',
    component: SideBarEntryIrrigation,
  },
  {
    path: 'alert/:alertId',
    component: SideBarEntryAlert,
  },

  {
    path: 'seasons/create',
    component: SeasonsSidebar,
  },
  {
    path: 'rackutil/:columnId/:refresh',
    component: SideBarEntryRackUtil,
  },
  {
    path: 'season/delete/:id',
    component: SeasonsSidebarDelete,
  },
  {
    path: 'seeds/create',
    component: SeedsSidebar,
  },
  {
    path: 'seeds/:seedId',
    component: SeedsSidebarEdit,
  },
  {
    path: 'costs/:costName',
    component: CostsSideBarEdit,
  },
  {
    path: 'season/trays/:seasonId',
    component: SideBarSeasonTrayEditor,
    fullscreen: true,
  },
  {
    path: 'season/:seasonId',
    component: SideBarSeasonEntry,
  },
  {
    path: 'sprinklercore/:deviceId',
    component: SideBarEntrySprinklerCore,
  },
  {
    path: 'sprinkler/:deviceId',
    component: SideBarEntrySprinkler,
  },
  {
    path: 'tray/:traySeasonId',
    component: SideBarEntryTraySeasonEntryPoint,
  },
  {
    path: 'co2/:deviceId',
    component: SideBarEntryCo2,
  },
  {
    path: 'dimmer/:deviceId',
    component: SideBarEntryDimmer,
  },
  {
    path: 'dimmercore/:deviceId',
    component: SideBarEntryDimmerCore,
  },
  {
    path: 'lighting/:deviceId',
    component: SideBarEntryLighting,
  },
  {
    path: 'lightingcore/:deviceId',
    component: SideBarEntryLightingCore,
  },
  {
    path: 'traybot/:deviceId',
    component: SideBarEntryTraybot,
  },
  {
    path: 'lift/:deviceId',
    component: SideBarEntryLift,
  },
  {
    path: 'liftcore/:deviceId',
    component: SideBarEntryLiftCore,
  },
  {
    path: 'camera/:deviceId',
    component: SidebarEntryCamera,
  },
  {
    path: 'harvester/:deviceId',
    component: SideBarEntryHarvester,
  },
  {
    path: 'sentry/:deviceId',
    component: SideBarEntrySentry,
  },
  {
    path: 'seeder/:deviceId',
    component: SideBarEntrySeeder,
  },
  {
    path: 'packager/:deviceId',
    component: SideBarEntryPackager,
  },
  {
    path: 'transfer/:deviceId',
    component: SideBarEntryTransfer,
  },
  {
    path: 'guard/:deviceId',
    component: SideBarEntryGuard,
  },
  {
    path: 'conveyor/:deviceId',
    component: SideBarEntryConveyor,
  },
  {
    path: 'dashboard/graph/edit/:id',
    component: SidebarCustomConsoleGraph,
  },
  {
    path: 'mcp',
    component: MCPSidebar,
  },
  {
    path: 'rules/create',
    component: RulesSidebar,
    fullscreen: true,
  },
  {
    path: 'rules/:ruleId',
    component: RulesSidebarEdit,
    fullscreen: true,
  },
];

export default routes;
